// extracted by mini-css-extract-plugin
export var menuItem = "B_vj f_gR f_cz f_cD f_cP f_z";
export var menuItemSub = "B_vk f_b2 f_cz f_cP";
export var menuMainLink = "B_vl f_gS f_fB";
export var menuLink = "B_vm f_gS f_fB";
export var Link = "B_tn v_tn v_sJ v_s2";